import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import UtpAdsRepository from '@/domain/repositories/UtpAdsRepository';
import UtpAdsDataRepository from '@/data/repositories/UtpAdsRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* getUtpAdsData(): any {
  try {
    XCheckpointManager.registerStart(`Utp anuncio`);
    yield put({ type: Types.GET_UTP_ADS_DATA_REQUEST });
    const utpAdsRepository: UtpAdsRepository = new UtpAdsDataRepository();
    const utpAdsResponse = yield call(utpAdsRepository.getUtpAdsData);
    if (!utpAdsResponse) {
      XCheckpointManager.registerEnd(`Utp anuncio`);
      throw new Error('error');
    }
    yield put({
      type: Types.GET_UTP_ADS_DATA_SUCCESS,
      data: utpAdsResponse
    });
    XCheckpointManager.registerEnd(`Utp anuncio`);
  } catch (error) {
    XCheckpointManager.registerEnd(`Utp anuncio`);
    yield put({
      type: Types.GET_UTP_ADS_DATA_FAILURE,
      error: 'Ocurrió un error al momento de leer los datos del anuncio.'
    });
  }
}
